import { createContext } from 'react';

const solicitudesGLBContext = createContext();

export default solicitudesGLBContext;